<template>
  <div class="home page-wrap">
    <TheAppList />
  </div>
</template>

<script>
import TheAppList from '@/components/TheAppList'

export default {
  name: 'home',
  components: {
    TheAppList
  }
}
</script>

<style lang="scss">
  @import '@/scss/main.scss';

</style>
